/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */
//@ts-ignore
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import React, { FC, useRef } from 'react';
// import Joyride from 'react-joyride'; // Joyride kaldırıldı
import { shallowEqual } from 'react-redux';
import { Redirect, Switch, Route } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/services/redux/app/store';
import { _setJoyride } from 'src/services/redux/slices/auth/auth-slice';
import { MasterLayout } from '../../_metronic/layout/MasterLayout';
import { ChatSocketProvider } from '../pages/messages/context/ChatSocketContext';
import { ChatNotifications } from '../pages/messages/components/ChatNotifications';
import { Logout, AuthPage } from '../modules/auth';
import { useHeartbeat } from '../hooks/useHeartbeat';
import { useActivityTracker } from '../hooks/useActivityTracker';
import { ErrorsPage } from '../modules/errors/ErrorsPage';
import CancelRefund from '../pages/contracts/cancel-refund';
import DistanceSalesContract from '../pages/contracts/distance-sales-contract';
import PrivacyAndSecurity from '../pages/contracts/privacy-and-security';
import HtmlPage from '../pages/html/HtmlPage';
import Maintance from '../pages/maintance';
import SharedPageRouter from '../pages/shared';
import PublicSurveyPage from '../pages/public/PublicSurveyPage';
import PublicSurveyInvitePage from '../pages/public/PublicSurveyInvitePage';
import PublicTransferView from '../pages/public/transfer-view';
import CareerApplyPage from '../pages/public/CareerApplyPage';
// import steps from '../utils/joyride'; // Artık kullanılmıyor
import { PrivateRoutes } from './PrivateRoutes';

// Heartbeat + canlı aktivite takibi. Chat soket context'ini tüketen bu hook'lar
// kasıtlı olarak null render eden ayrı bir bileşende: soket olayları (presence,
// typing, mesaj) sadece bu bileşeni yeniden render eder, rota ağacına dokunmaz.
const ActivityTrackers: FC = () => {
  useHeartbeat();
  useActivityTracker();
  return null;
};

const Routes: FC = () => {
  const dispatch = useAppDispatch();
  const tawkMessengerRef: any = useRef();
  const { isAuthorized } = useAppSelector((state) => state.auth, shallowEqual); // isJoyride kaldırıldı
  const { user } = useAppSelector((state) => state.auth);
  const handleMinimize = () => {
    tawkMessengerRef.current.minimize();
  };
  // Joyride callback kaldırıldı
  // const handleJoyrideCallback = (data: any) => {
  //   const { status } = data;
  //   if (status === 'finished' || status === 'skipped') {
  //     dispatch(_setJoyride());
  //   }
  // };

  if (user?.company?.is_maintance)
    return (
      <Switch>
        <Route>
          <Maintance />
        </Route>
      </Switch>
    );

  return (
    <Switch>
      <Route path="/distance-sales-contract" component={DistanceSalesContract} exact />
      <Route path="/privacy-and-security" component={PrivacyAndSecurity} exact />
      <Route path="/4x4-kampanya" render={() => <HtmlPage src="/kampanya.html" />} exact />
      <Route path="/cancel-refund" component={CancelRefund} exact />
      <Route path="/share/:shareKey" component={SharedPageRouter} />
      <Route path="/survey/davet/:token" component={PublicSurveyInvitePage} />
      <Route path="/survey/:slug" component={PublicSurveyPage} />
      <Route path="/t/:code" render={(props: any) => <PublicTransferView code={props.match.params.code} />} />
      {/* İK başvuru linki (LinkedIn "harici site" başvurusu) — giriş gerektirmez */}
      <Route path="/kariyer/:slug" component={CareerApplyPage} />

      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to="/" />
      )}

      <Route path="/logout" component={Logout} />

      {!isAuthorized ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to="/auth/login" />
      ) : (
        <ChatSocketProvider>
          <MasterLayout>
            {/* Joyride bileşeni kaldırıldı */}
            <PrivateRoutes />
            <Route path="/error" component={ErrorsPage} />
          </MasterLayout>
          <ChatNotifications />
          <ActivityTrackers />
        </ChatSocketProvider>
      )}
    </Switch>
  );
};

export { Routes };
